export default __webpack_public_path__ + "static/media/uv5_en_jing_b3.cead407f.mp3";